import { IGetDashboardFinanceiroChartUseCaseUseCase } from "../../../presentation/useCases/read/get_dashboard_financeiro_chart_use_case_use_case";
import { DashboardFinanceiroChart } from "../../models/dashboard_financeiro_chart";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * GetDashboardFinanceiroChartUseCaseUseCase
 */

export class GetDashboardFinanceiroChartUseCaseUseCase implements IGetDashboardFinanceiroChartUseCaseUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async execute(ano: number, mes?: number): Promise<DashboardFinanceiroChart[]> {
    return await this.repository.getDashboardFinanceiroChart(ano, mes);

  }
}
